import {
  APP_USER_GROUPING_PROJECT_PROFILE_MASTER_ROUTE,
  APP_USER_GROUPING_PROJECT_PROFILE_ROUTE,
} from "config/route-consts";
import { Switch } from "react-router-dom";

import { ProtectedRoute } from "pages/Authentication/ProtectedRoute";
import AppUserGroupingProjectProfileMaster from "./AppUserGroupingProjectProfileMaster/AppUserGroupingProjectProfileMaster";
import AppUserGroupingProjectProfileHistoryView from "./AppUserGroupingProjectProfileHistory/AppUserGroupingProjectProfileHistoryView";

function AppUserGroupingProjectProfileView() {
  return (
    <Switch>
      <ProtectedRoute
        path={APP_USER_GROUPING_PROJECT_PROFILE_MASTER_ROUTE}
        key={APP_USER_GROUPING_PROJECT_PROFILE_MASTER_ROUTE}
        component={AppUserGroupingProjectProfileMaster}
        // TODO: đổi lại thành auth(APP_USER_GROUPING_PROJECT_PROFILE_MASTER_ROUTE) khi BE đã đăng ký quyền cho route này
        auth={true}
      />
      <ProtectedRoute
        path={APP_USER_GROUPING_PROJECT_PROFILE_ROUTE}
        key={APP_USER_GROUPING_PROJECT_PROFILE_ROUTE}
        component={AppUserGroupingProjectProfileHistoryView}
        // TODO: đổi lại thành auth(APP_USER_GROUPING_PROJECT_PROFILE_ROUTE) khi BE đã đăng ký quyền cho route này
        auth={true}
      />
    </Switch>
  );
}

export { AppUserGroupingProjectProfileMaster };
export default AppUserGroupingProjectProfileView;
